import { render, staticRenderFns } from "./ClientForm.vue?vue&type=template&id=06940f9a&scoped=true"
import script from "./ClientForm.vue?vue&type=script&lang=ts"
export * from "./ClientForm.vue?vue&type=script&lang=ts"
import style0 from "./ClientForm.vue?vue&type=style&index=0&id=06940f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06940f9a",
  null
  
)

export default component.exports